import "../styles/dashboard.css";
import MessageList from "../components/MessageList/MessageList";
import NotificationHeader from "../components/NotificationHeader/NotificationHeader";
import React, { useEffect, useState } from "react";
import SearchBox from "../components/SearchBox/SearchBox";
import UsersList from "../components/UsersList/UsersList";
import Swal from "sweetalert2";
import axiosInstance from "../api/axiosInstance";

const Dashboard = ({ setIsNewUserAdded }) => {
  const [isCreateUser, setIsCreateUser] = useState(false);
  const [isEditUser, setIsEditUser] = useState(false);
  const [messageIds, setMessageIds] = useState([]);
  const [messages, setMessages] = useState([]);
  const [filteredMessages, setFilteredMessages] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const { user } = JSON.parse(localStorage.getItem("auth")) || { user: {} };

  const handleClearAllMessages = () => {
    if (messageIds.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No messages to clear",
        text: "There are no messages available to clear.",
        customClass: {
          confirmButton: "custom-swal-button",
        },
        buttonsStyling: false,
      });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to clear all messages?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, clear them!",
      cancelButtonText: "No, cancel!",
      customClass: {
        confirmButton: "yes-button",
        cancelButton: "cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        clearMessages();
      }
    });
  };

  const clearMessages = async () => {
    try {
      const response = await axiosInstance.put("user/delete-messages", {
        messageIds,
      });

      if (response.status === 200) {
        Swal.fire({
          title: "Success",
          text: response.data.message || "Messages cleared successfully!",
          icon: "success",
          customClass: {
            confirmButton: "custom-swal-button",
          },
          buttonsStyling: false,
        });

        setMessages([]);
        setFilteredMessages([]);
        setMessageIds([]);
      }
    } catch (error) {
      console.error("Error clearing messages:", error);
    }
  };

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await axiosInstance.get("message/user");

        if (response.status === 200 && response.data) {
          setMessageIds(response.data.messages.map((message) => message._id));
          setMessages(response.data.messages);
          setFilteredMessages(response.data.messages);
        }
      } catch (error) {
        console.error("🚀 -> fetchMessages -> error:", error);
      }
    };

    fetchMessages();
  }, []);

  const handleSearch = (term) => {
    setSearchTerm(term);

    if (term.trim() === "") {
      setFilteredMessages(messages);
    } else {
      setFilteredMessages(
        messages.filter((message) => message.to?.toString().includes(term))
      );
    }
  };

  return (
    <>
      <NotificationHeader
        name={user.isAdmin ? "User Management" : "Incoming SMS Messages"}
      />
      <div className="dashboardPage">
        <div className="container">
          <div className="pageStyle">
            {!isCreateUser && !isEditUser && (
              <div className="row">
                <div className="col-lg-6 col-md-6 col-12">
                  {!user.isAdmin && <SearchBox onSearch={handleSearch} />}
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                  <div className="text-end">
                    {user.isAdmin ? (
                      <button
                        className="primaryBtn"
                        onClick={() => setIsCreateUser(true)}
                        type="button"
                      >
                        Create User
                      </button>
                    ) : (
                      <button
                        onClick={handleClearAllMessages}
                        className="primaryBtn"
                        type="button"
                      >
                        Clear
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-12">
                {user.isAdmin ? (
                  <UsersList
                    setIsNewUserAdded={setIsNewUserAdded}
                    isCreateUser={isCreateUser}
                    isEditUser={isEditUser}
                    setIsCreateUser={setIsCreateUser}
                    setIsEditUser={setIsEditUser}
                  />
                ) : (
                  <MessageList messages={filteredMessages} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
